export default __webpack_public_path__ + "static/media/768.e44dc76c.png";